export const DROPDOWN = "dropDown";
export const COMBOBOX = "comboBox";
export const MULTISELECT = "multiSelect";
export const RADIO = "radio";
